import { Component } from '@angular/core';

@Component({
  selector: 'app-hero-section-box',
  templateUrl: './hero-section-box.component.html',
  styleUrls: ['./hero-section-box.component.scss']
})
export class HeroSectionBoxComponent {

}
